require("jquery");
require("jquery-validation")($);
require("jquery-validation-unobtrusive");
require("../node_modules/jquery.maskedinput/src/jquery.maskedinput");
